let ServerAccountList = [
    {
        shoukuan: '百度云',
        zhanghao: '充值余额支付',
        server: '百度云',
        account: 'kun2020_0329',
        yuanyin: '统一续费到'
    }, {
        shoukuan: '阿里云',
        zhanghao: '充值余额支付',
        server: '阿里云',
        account: '阿费利克斯',
        yuanyin: '统一续费到'
    }, {
        shoukuan: '阿里云',
        zhanghao: '充值余额支付',
        server: '阿里云',
        account: '925552666@qq.com',
        yuanyin: '统一续费到'
    }, {
        shoukuan: 'Godaddy',
        zhanghao: '扫码支付',
        server: 'Godaddy',
        account: '194512438（廖 松坤）',
    }
];
export default ServerAccountList